import ne, { STORAGE_KEYS as s } from "./storage-manager.js";
import { logger as N } from "../../shared-lib/index.js";
var Bt = {
  Ya: function Ya(e) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var t = !1;

    try {
      if (localStorage && localStorage.getItem) try {
        localStorage.setItem(s.gt.ac, "true"), localStorage.getItem(s.gt.ac) && (localStorage.removeItem(s.gt.ac), t = !0);
      } catch (e) {
        if (!(e instanceof Error && ("QuotaExceededError" === e.name || "NS_ERROR_DOM_QUOTA_REACHED" === e.name) && localStorage.length > 0)) throw e;
        t = !0;
      }
    } catch (e) {
      N.info("Local Storage not supported!");
    }

    var r = Bt.cc(),
        a = new ne.lc(e, r && !o, t);
    var n;
    return n = t ? new ne.gc(e) : new ne.uc(), new ne(a, n);
  },
  cc: function cc() {
    return navigator.cookieEnabled || "cookie" in document && (document.cookie.length > 0 || (document.cookie = "test").indexOf.call(document.cookie, "test") > -1);
  }
};
export default Bt;